"use client";

import { useMotion } from "@/contexts/MotionContext";
import { motion } from "framer-motion";

export default function ServicesHeroAnimation() {
  const { isMotionEnabled } = useMotion();

  return (
    <div className="relative w-full h-full">
      {/* Browser Window */}
      <motion.div
        className="absolute top-4 left-4 bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
        animate={
          isMotionEnabled
            ? {
                width: ["200px", "300px", "200px"],
                height: ["150px", "200px", "150px"],
              }
            : {}
        }
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        {/* Browser Chrome */}
        <div className="h-6 bg-gray-100 dark:bg-gray-700 flex items-center px-2 gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-red-400" />
          <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
          <div className="w-2.5 h-2.5 rounded-full bg-green-400" />
          <div className="text-xs ml-2 text-gray-700 dark:text-gray-300">
            localhost:3000
          </div>
        </div>
        {/* Browser Content */}
        <div className="p-3">
          <div className="w-full h-3 bg-gray-200 dark:bg-gray-600 rounded mb-2" />
          <div className="w-2/3 h-3 bg-gray-200 dark:bg-gray-600 rounded" />
        </div>
      </motion.div>

      {/* Terminal Window */}
      <motion.div
        className="absolute bottom-4 right-4 w-64 h-40 bg-black rounded-lg shadow-lg overflow-hidden"
        initial={{ opacity: 0 }}
        animate={isMotionEnabled ? { opacity: 1 } : { opacity: 1 }}
      >
        {/* Terminal Chrome */}
        <div className="h-6 bg-gray-800 flex items-center px-2 gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-red-400" />
          <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
          <div className="w-2.5 h-2.5 rounded-full bg-green-400" />
        </div>
        {/* Terminal Content */}
        <div className="p-3 font-mono text-sm text-green-400">
          <motion.div
            animate={
              isMotionEnabled
                ? {
                    opacity: [1, 1, 0],
                  }
                : {
                    opacity: 1,
                  }
            }
            transition={{
              duration: 0.8,
              repeat: Infinity,
              times: [0, 0.5, 1],
            }}
            className="inline-block w-2 h-4 bg-green-400 ml-1"
          />
          <motion.div
            initial={{ width: 0 }}
            animate={isMotionEnabled ? { width: "auto" } : { width: "auto" }}
            transition={
              isMotionEnabled
                ? {
                    duration: 2,
                    repeat: Infinity,
                    repeatDelay: 1,
                  }
                : {
                    duration: 0,
                  }
            }
            className="overflow-hidden whitespace-nowrap"
          >
            npm install @township/ui
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}
